import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import UserContext from 'src/services/UserContext';
import { QaErrorsTimestamp } from '../types/QaErrors';
import { getLastRefreshTimestamp } from '../api/qaErrors.api';

export type QaErrorsTimestampState = FetchState<QaErrorsTimestamp>;

const initialState: QaErrorsTimestampState = {
  loading: false,
  error: false,
  data: null,
};

const useQaErrorsTimestampFetch = (): [QaErrorsTimestampState, () => void] => {
  const [{ loading, data, error }, refetch] = useFetchReducer(getLastRefreshTimestamp, []);

  const state: QaErrorsTimestampState = { ...initialState, loading, error };

  if (data === null) {
    return [state, refetch];
  }

  return [
    {
      ...state,
      data: UserContext.reformatPDTDate(data, 'MMMM D, YYYY [at] h:mm:ss A z'),
    },
    refetch,
  ];
};

export default useQaErrorsTimestampFetch;
